export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'serviceJobSplitBilling';
export const NAME = 'ServiceJobSplitBilling';
export const COLUMN_SHARE_PERCENTAGE = 'SHARE_PERCENTAGE';
export const COLUMN_DISCOUNT_PERCENT = 'DISCOUNT_PERCENT';
export const COLUMN_DISCOUNT_AMOUNT = 'DISCOUNT_AMOUNT';
export const SPLIT_PARTY = 'SplitParty';
export const CUSTOMER_ID = 'CustomerId';
export const PARTS = 'PARTS';
export const MAX_SHARE_PERCETAGE = 100;
export const DEFAULT = 'DEFAULT';
export const DEALER = 'Dealer';
export const DEFAULT_INDEX = 0;
export const DEFAULT_ID = 1;
export const SPLIT_PARTIES = {
	Warranty: 'Warranty',
	Goodwill: 'Goodwill',
	Dealer: 'Internal',
	Insurance: 'Insurance',
	Corporate: 'Corporate',
	Individual: 'Individual',
};
